import { render, staticRenderFns } from "./recordmanage.vue?vue&type=template&id=59cef9bc&scoped=true"
import script from "./recordmanage.vue?vue&type=script&lang=js"
export * from "./recordmanage.vue?vue&type=script&lang=js"
import style0 from "./recordmanage.vue?vue&type=style&index=0&id=59cef9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cef9bc",
  null
  
)

export default component.exports